<div class="login-container">
  <app-header-title
    [title]="'Crie sua conta'"
    [link]="'/auth'"
  ></app-header-title>

  <form [formGroup]="form" class="login-form">
    <div class="form-group">
      <label for="email">E-mail</label>
      <input
        id="email"
        type="email"
        formControlName="email"
        class="form-control"
      />
      @if(form.get('email')?.invalid && form.get('email')?.touched){
      <small class="error"> E-mail é obrigatório </small>
      }
    </div>
    <div class="form-group">
      <label for="email">Nome</label>
      <input
        id="name"
        type="name"
        formControlName="name"
        class="form-control"
      />
      @if(form.get('name')?.invalid && form.get('name')?.touched){
      <small class="error"> Nome é obrigatório </small>
      }
    </div>

    <div class="form-group">
      <label for="password">Senha</label>
      <input
        id="password"
        type="password"
        formControlName="password"
        class="form-control"
      />
      @if(form.get('password')?.invalid &&form.get('password')?.touched){
      <small class="error"> Senha é obrigatória </small>
      }
    </div>
    <div class="form-group">
      <label for="password">Confirma senha</label>
      <input
        id="password"
        type="password"
        formControlName="confirmPassword"
        class="form-control"
      />
      @if(form.get('confirmPassword"')?.invalid
      &&form.get('confirmPassword"')?.touched){
      <small class="error">Confirmar senha é obrigatória </small>
      }
    </div>
  </form>
  <div class="login-footer">
    <button
      (click)="create()"
      type="submit"
      [disabled]="form.invalid"
      class="btn btn-primary"
    >
      CONTINUAR
    </button>
    <a routerLink="/login" class="forgot-password">Já tem conta?</a>
  </div>
</div>
